import { propertyHelper } from "@iso/lib/helpers/propertyHelper";

// Pages hidden from free (Bronze) properties.
export function hiddenKeys () {
    return ['health-safety', 'safety-documents', 'safe-farm', 'manage-sensors', 'spray', 'activity', 'incidents', ...silverKeys()];
};

// Hidden pages that Silver properties can open as well as Gold.
export function silverKeys () {
    return ['weather'];
};

// Whether a property on this subscription can open a hidden page.
export function hasPlanAccess (key, subscription) {
    return propertyHelper.checkIsGoldPackage(subscription)
        || (silverKeys().includes(key) && propertyHelper.checkIsSilverPackage(subscription));
};
